import React, { FC } from 'react';
import { L, Units, UNITS } from 'harmony-language';
import { Select } from './select';

interface SelectUnitsProps {
    units: Units | null;
    onChange: (u: Units) => void;
}

export const SelectUnits: FC<SelectUnitsProps> = (props) => {
    const { units, onChange } = props;
    const menuItems = [
        { id: UNITS.Imperial, value: UNITS.Imperial, label: L.unitsImperial() },
        { id: UNITS.Metric, value: UNITS.Metric, label: L.unitsMetric() }
    ];
    const item = menuItems.find(x => x.value === (units ? units : UNITS.Imperial));

    return (
        <Select
            label={L.measurementSystem()}
            list={menuItems}
            item={item}
            onChange={(v) => onChange(v.value)}/>
    );
};
